import React from 'react';
import styled from 'styled-components';

const Layout = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'flex-start')};
  flex-direction: column;
  text-align: ${(props) => (props.right ? 'end' : 'left')};
  padding: 16px;
  border-bottom ${(props) => props.line && ''};
`;

const Line = styled.div`
display: flex;
  width: 100%;
  border-bottom ${(props) => props.line && '1px solid #E4E6EB'};


`;

const Title = styled.div`
  color: #adadad;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 4px;
`;

const Text = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const TitleAndTextInternalCard = ({ title, text, right, line }) => (
  <>
    <Line line={line}>
      <Layout right={right}>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </Layout>
    </Line>
  </>
);

export default TitleAndTextInternalCard;
